<template>
    <div>
        <vpsHeader></vpsHeader>
        <div class="suspend-error-container">
            <h2 class="err-head-pos">Your UserId has been suspended</h2>
            <h2>Please contact an Administrator at your</h2>
            <h2>company or contact the Verizon Care team</h2>
            <h2>vps-care@verizon.com</h2>
        </div>
        <vpsFooter></vpsFooter>
    </div>
</template>

<script>
import vpsHeader from '@/vbgauth/components/vpsHeader'
import vpsFooter from '@/vbgauth/components/vpsFooter'
export default {
    name: "VPSUserSuspendedPage",
    components: {
        vpsHeader,
        vpsFooter
    },
    data() {
        return {
            
        };
    },
    mounted() {

    },
};
</script>
<style scoped>
.suspend-error-container {
    width: 100%;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 280px;
    word-break: break-word;
}

.err-head-pos {
    margin-bottom: 30px;
}
</style>